<template>
  <div class="situation-container container">
    <span class="basic-title">设备情况：</span>
    <div class="ambulance-info">
      <el-row class="info-row">
        <el-col class="info-key" :span="2" :offset="0">
          开始时间：
        </el-col>
        <el-col class="info-item" :span="3" :offset="0">
          {{ ambulance?.name }}({{ ambulance?.idName }})
        </el-col>
        <el-col class="info-key" :span="2" :offset="1">
          结束时间：
        </el-col>
        <el-col class="info-item" :span="3" :offset="0">
          {{ patient.done_time }}
        </el-col>
        <el-col class="info-key" :span="2" :offset="1">
          总用时：
        </el-col>
        <el-col v-if="patient.costTime" class="info-item" :span="3" :offset="0">
          {{ Math.round(patient.costTime / 60) }}
          <span v-if="patient.costTime">分钟</span>
        </el-col>
        <el-col class="info-key" :span="2" :offset="1">
          地点：
        </el-col>
        <el-col class="info-item" :span="6" :offset="0">
          {{ patient.patientAddr }}
        </el-col>
      </el-row>
      <el-row class="info-row">
        <el-col class="info-key" :span="2" :offset="0">
          设备数据:
        </el-col>
        <el-col :span="4">
          <smart-recording/>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import SmartRecording from "@components/patientsSmart/SmartRecording";
import { baseUrl } from "@/utils/base";
import { mapState } from "vuex";

export default {
  name: "SmartStatus",
  components: {
    SmartRecording,
  },
  data() {
    return {
      baseUrl: baseUrl,
    };
  },
  computed: {
    ...mapState({
      patient: "showOrEditPatientInfo"
    }),
    ambulance() {
      return this.patient?.ambulance;
    },
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.ambulance-info {
  padding-top: 12px;
}
</style>
